import { MarketingDrawer, PageTitle } from '@app/components/general'
import { metaSetter } from '@app/utils'
import { SectionContainer } from '@app/components/stateless/containers/section-container'
import { Header2, Header3 } from '@app/components/general/header'
import { classNames } from '@app/utils/classes'
import { Box } from '@app/components/general/box'
import { useTranslation } from '@app/lib/hooks/useTranslation'
import { Paragraph } from '@app/components/stateless/typo/paragraph'
import loadNamespaces from 'next-translate/loadNamespaces'
import type { GetStaticProps } from 'next'
import { I18nDictionary } from 'next-translate'
import { SUPPORT_EMAIL } from '@app/configs/app-config'

export const getStaticProps: GetStaticProps<{
  __lang: string
  __namespaces?: Record<string, I18nDictionary>
}> = async (ctx) => {
  return {
    props: await loadNamespaces({
      ...ctx,
      pathname: '/contact',
    }),
  }
}

const center = 'flex flex-col place-items-center place-content-center'
const circlesClass = `min-w-[14rem] rounded-full ${center} px-5 py-4 hover:bg-blue-600 focus:bg-blue-700`

function Contact() {
  const { t } = useTranslation('contact')

  return (
    <MarketingDrawer>
      <SectionContainer block container>
        <div className='pb-30'>
          <PageTitle>{t('header')}</PageTitle>
          <Paragraph>{t('header-details')}</Paragraph>
        </div>
        <Header2>{t('questions')}</Header2>
        <Paragraph>{t('questions-details')}</Paragraph>
        <div className='space-y-3 pt-4'>
          <Header3>{t('interested')}</Header3>
          <Paragraph>{t('interested-details')}</Paragraph>
        </div>
        <div className={classNames('gap-y-2 py-8', center)}>
          <address>
            <a
              href={`mailto:${SUPPORT_EMAIL}`}
              className={'text-blue-500 decoration-none'}
            >
              <Box
                className={classNames(
                  'bg-blue-300 text-black font-bold md:text-xl',
                  circlesClass
                )}
              >
                {t('email')}
              </Box>
            </a>
          </address>
        </div>
      </SectionContainer>
    </MarketingDrawer>
  )
}

export default metaSetter(
  { Contact },
  {
    translation: 'contact',
  }
)
